export default "__VITE_ASSET__BXAjgoqZ__"